import Icon from "assets/icons";
import { AITextEnhancementActionItem } from "./type";
import TextEnhancementType from "shared/enums/TextEnhancementType";
import EnhancementFieldType from "shared/enums/EnhancementFieldType";
import EnhancementFailureReason from "shared/enums/EnhancementFailureReason";
import I18n from "shared/types/I18n";

export const AIEnhancerActionsList: Array<AITextEnhancementActionItem> = [
  {
    actionKey: TextEnhancementType.POLISH,
    copyKey: "ai.text.action.polish",
    infoCopyKey: "ai.text.action.polish.info",
    icon: <Icon.Add />
  },
  {
    actionKey: TextEnhancementType.FORMALIZE,
    copyKey: "ai.text.action.formalize",
    infoCopyKey: "ai.text.action.formalize.info",
    icon: <Icon.Add />
  },
  {
    actionKey: TextEnhancementType.ELABORATE,
    copyKey: "ai.text.action.elaborate",
    infoCopyKey: "ai.text.action.elaborate.info",
    icon: <Icon.Add />
  },
  {
    actionKey: TextEnhancementType.SHORTEN,
    copyKey: "ai.text.action.shorten",
    infoCopyKey: "ai.text.action.shorten.info",
    icon: <Icon.Add />
  },
  {
    actionKey: TextEnhancementType.FIRST_PERSON,
    copyKey: "ai.text.action.in.first.person",
    infoCopyKey: "ai.text.action.in.first.person.info",
    icon: <Icon.Add />
  }
];

export function getAITextActions(enhancementFieldType?: EnhancementFieldType): Array<AITextEnhancementActionItem> {
  switch (enhancementFieldType) {
    case EnhancementFieldType.TABLE_TALK_BIO:
      return AIEnhancerActionsList;
    default:
      return AIEnhancerActionsList.filter(o => o.actionKey !== TextEnhancementType.FIRST_PERSON);
  }
}

export function getInvalidTextToDisplay(reason: EnhancementFailureReason): keyof I18n {
  switch (reason) {
    case EnhancementFailureReason.ABUSIVE_CONTENT:
      return "ai.assist.failure.abusive.content";
    case EnhancementFailureReason.COULD_NOT_COMPREHEND:
      return "ai.assist.failure.could.not.comprehend";
  }
}
